import { Box, Button, IconFont, Popover } from '@byecode/ui'
import { ActorEvent, EVENT_TYPE, ScrollEventProtocol, TimerEventProtocol } from '@lighthouse/core'
import React, { useState } from 'react'

import { OtherEventConfig } from './OtherEventConfig'
import { ScrollEventConfig } from './ScrollEventConfig'
import { TimerEventConfig } from './TimerEventConfig'

interface EventConfigProps {
    value: ActorEvent
    onChange: (value: ActorEvent) => void
}

export const EventConfig: React.FC<EventConfigProps> = ({ value, onChange }) => {
    const [opened, setOpened] = useState(false)

    return (
        <Box onClick={ev => ev.stopPropagation()}>
            <Popover width={360} position="bottom" withinPortal opened={opened} onChange={setOpened}>
                <Popover.Target>
                    <Button type="text" size="xs" icon={<IconFont type="ControlComponent" size={16} />}></Button>
                </Popover.Target>
                <Popover.Dropdown>
                    {value.type === EVENT_TYPE.SCROLL_BOTTOM ? (
                        <ScrollEventConfig value={value as ScrollEventProtocol} onChange={onChange} />
                    ) : value.type === EVENT_TYPE.TIMER ? (
                        <TimerEventConfig value={value as TimerEventProtocol} onChange={onChange} />
                    ) : (
                        <OtherEventConfig value={value} onChange={onChange} />
                    )}
                </Popover.Dropdown>
            </Popover>
        </Box>
    )
}
